module.exports = ":host {\n    position: relative;\n    display: block;\n    background-color: white;\n}"